import { render, staticRenderFns } from "./video_projects.vue?vue&type=template&id=19ad1f60&"
import script from "./video_projects.vue?vue&type=script&lang=js&"
export * from "./video_projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports